//initial redux
import { put, call, takeEvery, fork, all, take, select } from "redux-saga/effects";
import * as router from "react-router-redux";
import { eventChannel, delay } from "redux-saga";
import reportsservice from "../../../../services/reports";
import moment from "moment";
import pointsservice from "../../../../services/points";
import { unitsservice, DateTime, pointName, array, string } from "../../../../utils";
import rules from "../../../../services/rules";

const initialState = {
	instances: {}
};

/////////
//types
export const types = {
	INIT_TABLE: "components/learnedtable/INIT_TABLE",
	LOAD_DATA: "components/learnedtable/LOAD_DATA",
	SET_TABLE_DATA: "components/learnedtable/SET_TABLE_DATA"
};

function initTable(state, action) {
	const id = action.payload.id;
	const component = action.payload.component;
	//do nothing if it's already init
	if (state.instances.id) {
		return state;
	}
	let tableData = {
		pointInfo: [],
		headers: [],
		rows: []
	};
	component.inputs.forEach(input => {
		if (input.type === "Dynamic") {
			input.values.forEach(value => {
				tableData.pointInfo.push({
					pointId: value,
					units: "",
					name: ""
				});
			});
		}
	});
	let newState = { ...state, instances: { ...state.instances, [id]: tableData } };
	return newState;
}

function setTableData(state, action) {
	const id = action.payload.id;
	const tableData = action.payload.tableData;
	return { ...state, instances: { ...state.instances, [id]: tableData } };
}

///////////
//reducers
export const reducers = {
	reducer(state = initialState, action) {
		switch (action.type) {
			case types.INIT_TABLE: {
				return initTable(state, action);
			}
			case types.LOAD_DATA: {
				return state;
			}
			case types.SET_TABLE_DATA: {
				return setTableData(state, action);
			}
			default:
				return state;
		}
	}
};

//////////
//sagas
export const sagas = {
	*rootSaga() {
		yield all([this.loadData()]);
	},

	*loadData() {
		yield takeEvery(types.LOAD_DATA, function*({ payload }) {
			const component = payload.component;
			const id = payload.id;
			const fromDate = DateTime.toISOstringUTC(payload.timePeriod.startDate);
			const toDate = DateTime.toISOstringUTC(payload.timePeriod.endDate);

			const { ruleInstance, lookups, lookupsResults } = yield call(
				rules.GetLookupsForLearnedRule,
				payload.ruleInstanceId,
				fromDate,
				toDate
			);

			const setPoints = ruleInstance.config.fieldVars.setPoints;

			lookups.push({
				lookupRuleId: "No Match",
				ruleInstanceId: payload.ruleInstanceId
			});

			lookupsResults.forEach(lookup => {
				if (lookup.lookupRuleId === null || lookup.lookupRuleId === undefined) {
					lookup.lookupRuleId = "No Match";
				}
			});

			let tableRows = [];
			let grouped = {};
			//sort lookups into whatever columns have values and build headers
			if (lookups.length) {
				const lookup = lookups[0];
				for (var prop in lookup) {
					if (lookup.hasOwnProperty(prop)) {
						if (prop.startsWith("param") && !prop.endsWith("Range")) {
							const paramNum = parseInt(/\d+/.exec(prop)[0]);
							grouped[paramNum] = grouped[paramNum] || [];
							const rsgrouped = array.groupBy(lookups, x => x[prop]);
							for (var prop2 in rsgrouped) {
								if (rsgrouped.hasOwnProperty(prop2) && prop2 !== "null" && prop2 !== "undefined") {
									grouped[paramNum] = grouped[paramNum].concat(rsgrouped[prop2]);
								}
							}
						}
					}
				}

				// grouped["No Match"] = lookups.filter(x => x.lookupRuleId === "No Match");

				for (var prop in grouped) {
					if (grouped.hasOwnProperty(prop)) {
						if (grouped[prop].length) {
							const header = { title: "Param " + prop, number: parseInt(prop), lookups: grouped[prop] };
							tableRows.push(header);
							for (let index = 0; index < header.lookups.length; index++) {
								const lookup = header.lookups[index];
								lookup.results = lookupsResults
									.filter(x => x.lookupRuleId == lookup.lookupRuleId)
									.map(x => ({
										...x,
										passedPoints: JSON.parse(x.passedPointsJson, string.toCamelCase)
									}));
							}
						}
					}
				}
			}

			tableRows = tableRows.sort();
			const maxOutputCount = tableRows.reduce(
				(max, next) =>
					Math.max(max, next.lookups.reduce((max2, lookup) => Math.max(max2, lookup.output.length), 0)),
				0
			);
			tableRows.forEach((x, i) => (x.index = i));

			yield put(actions.setTableData(id, { tableRows, lookups, setPoints, maxOutputCount }));
			if (payload.onLoadComplete) {
				payload.onLoadComplete();
			}
		});
	}
};

////////
//actions
export const actions = {
	initTable(id, component) {
		return {
			type: types.INIT_TABLE,
			payload: { id, component }
		};
	},
	loadData(id, component, timePeriod, ruleInstanceId, onLoadComplete) {
		return {
			type: types.LOAD_DATA,
			payload: { id, component, timePeriod, ruleInstanceId, onLoadComplete }
		};
	},
	setTableData(id, tableData) {
		return {
			type: types.SET_TABLE_DATA,
			payload: { id, tableData }
		};
	}
};



// WEBPACK FOOTER //
// ./src/components/ReportComponents/Tables/LearnedRuleTable/redux.js